import './_init';
import './_positions';

class Main {
  constructor(){
    // CSSPlugin.defaultForce3D = false;
    // app.contentScale = 0.9;
    // app.verticalScale = 0.9;

    // var pers = util.getUrlVars('perspective');
    // var deg = util.getUrlVars('rotation');
    // var long = util.getUrlVars('shrink');
    // var sc = $.ua =
    // var bg = util.getUrlVars('bg');
    // if ( pers ){
    //   $('#stage').css({
    //     perspective: pers + 'px'
    //   });
    //   $('#debug [name="perspective"]').val(pers)
    // }
    // if ( sc ){
    //   app.contentScale = sc;
    //   $('#debug [name="scale"]').val(sc)
    // }
    // if ( deg ){
    //   $('#surface').css({
    //     transform: 'rotateX('+deg+'deg)'
    //   })
    //   $('#debug [name="rotation"]').val(deg)
    //   // TweenMax.set('#surface', { rotationX: 25 });
    // }

    // if ( long ){
    //   app.verticalScale = long;
    //   $('#debug [name="shrink"]').val(long)
    // }
    // if ( bg == 1 ){
    //   $('#surface').css({
    //     background: 'lightgray'
    //   });
    //   $('#debug [name="bg"]').val(bg)

    // }


    var ua = navigator.userAgent.toLowerCase();
    app.ua = {
      // Windows
      isWindows: /windows/.test(ua),
      // Mac
      isMac: /macintosh/.test(ua),
      // PC
      isPC : /windows/.test(ua) || /macintosh/.test(ua) || /ipad/.test(ua),
      // IE
      isIE: /msie (\d+)/.test(ua) || (ua.indexOf('trident/7') > -1) || /edge (\d+)/.test(ua),
      // isIE: /macintosh/.test(ua),　//IEをmacで制限するテスト
      // IE6
      isIE6: /msie (\d+)/.test(ua) && RegExp.$1 == 6,
      isIE7: /msie (\d+)/.test(ua) && RegExp.$1 == 7,
      // IE9未満
      isLtIE9: /msie (\d+)/.test(ua) && RegExp.$1 < 9,
      // IE10未満
      isLtIE10: /msie (\d+)/.test(ua) && RegExp.$1 < 10,
      // Firefox
      isFirefox: /firefox/.test(ua),
      // WebKit
      isWebKit: /applewebkit/.test(ua),
      // タッチデバイス
      isTouchDevice: 'ontouchstart' in window,
      // iOS
      isIOS: /i(phone|pod|pad)/.test(ua),
      // iPhone、iPod touch
      isIPhone: /i(phone|pod)/.test(ua),
      // iPad
      isIPad: /ipad/.test(ua),
      // Android
      isAndroid: /android/.test(ua),
      // モバイル版Android
      isAndroidMobile: /android(.+)?mobile/.test(ua),
      isSmartPhone : /i(phone|pod)/.test(ua) || /android(.+)?mobile/.test(ua)
    };
    if ( app.ua.isWindows ){
      $('html').addClass('windows');
    }

    function onOrientationChange ( mql ) {
    if ( mql.matches ) {
        $('html').addClass('newPortrait')
        $('html').removeClass('newLandscape')
      } else {
        $('html').addClass('newLandscape')
        $('html').removeClass('newPortrait')
      }
    }
    var mql = window.matchMedia( "(orientation: portrait)" );
    mql.addListener( onOrientationChange );
    onOrientationChange( mql );

    $(window).on('resize', function() {
      if (window.matchMedia('(max-width:760px)').matches) {
        app.media = 'sp';
        app.contentScale = 0.9;
        app.verticalScale = 1;
        app.parseRevise = 0.20;
        app.topMainHeightShort = 0;

        app.verticalScaleY = app.contentScale * app.verticalScale;

      } else {
        app.media = 'pc';
        if ( app.ua.isIE ){
          app.contentScale = 0.7;
          app.verticalScale = 1;
          app.parseRevise = 0;
          app.topMainHeightShort = 0;
          TweenMax.set('#surface', { rotationX: 0 });
        } else {
          app.contentScale = 0.7;
          app.verticalScale = 1;
          app.parseRevise = 0.3;
          app.topMainHeightShort = 0;
        }
        app.verticalScaleY = app.contentScale * app.verticalScale;
      }
    });
    $(window).resize();

    if ( !app.$tempPersonDetailMain ){
      app.$tempPersonDetailMain = $($('#tempPersonDetailMain').remove().text());
    }

    if ( !app.$tempOtherPeople ){
      app.$tempOtherPeople = $($('#tempOtherPeople').remove().text());
    }


    app.personsArr = this.createPersonArr();

    app.modals = new Modals();
    app.modals.news = new News('news');
    app.modals.welfare = new Welfare('welfare');
    app.modals.modalContact = new ModalContact('modalContact');
    app.modals.entry = new Entry('entry');
    app.modals.detail = new Detail('detail');

    //topページ専用
    if ( $('body').is('.index') ){
      app.top = new Top();
      if ( location.href.indexOf('192.168') != -1 ){
        TweenMax.to('#loading,#intro', 0.1, { autoAlpha: 0 });
        app.top.start();
      } else {
        var $progress = $('#loading .progress');
        // app.top.start();
        $('#wrapper').imagesLoaded()
          .always( ( instance )=> {
            // console.log('always');
            new TimelineMax()
            .to({}, 1, {})
            .to('#intro,#loading', 0.5, { autoAlpha: 0 })
            .add(()=>{
              app.top.start();
            })
          })
          .done( function( instance ) {
            // console.log('all images successfully loaded');
          })
          .fail( function() {
            // console.log('all images loaded, at least one is broken');
          })
          .progress( ( instance, image )=> {
            const per = 100 - Math.floor(instance.progressedCount / instance.images.length * 100);
            TweenMax.to( $progress, 0.5, { x: - per+'%', ease: Power0.easeInOut});

          });
      }
    } else {
      // TweenMax.to('#loading', 0.1, { autoAlpha: 0 });
    }

    // リクルート詳細ページ
    if ( $('body').is('.recruitDetail') ){
      this.persons = app.personsArr;
      var otherPeoples = [];
      $.each(this.persons, (i,el)=>{
        // console.log(el.otherPeople());;
        if ( el.id == '00' ){
          return;
        }
        var cont = el.otherPeople();
        otherPeoples.push(cont);
      });
      $('#recruitOtherPeople').html(otherPeoples);

      this.slider = $('#recruitOtherPeople').slick({
        appendArrows: $('#recruitOtherPeople'),
        prevArrow: '<div class="arrow prev"></div>',
        nextArrow: '<div class="arrow next"></div>',
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        draggable: false,
        centerPadding: 0,
        responsive: [
          {
            breakpoint: 760,
            settings: {
              infinite: true,
              speed: 200,
              // centerMode: true
              // centerPadding: 0,
              draggable: true,
              slidesToShow: 4,
              slidesToScroll: 1,
              swipeToSlide: true,
              arrows: false
            }
          },
        ]
      });

    }

    // sp用メニュー
    var $trigger = $('#menuTrigger');
    $trigger.on({
      click: ()=>{
        if ( $trigger.is('.open') ){
          $trigger.removeClass('open');
        } else {
          $trigger.addClass('open');
        }
      }
    });

    var $gloabalNav = $('#globalNav li');
    $gloabalNav.on({
      click: ()=>{
        $trigger.removeClass('open');
      }
    })
  }
  createPersonArr(){
    var data = app.data;
    var positions = app.positions;
    var monstterId = '00';
    var ceoId = '02';

    //ドラゴンを取り出す
    var monster = _.find(data,(obj)=>{
      return obj.id == monstterId;
    });
    //ceoを取り出す
    var ceo = _.find(data,(obj)=>{
      return obj.id == ceoId;
    });
    // 2人を除いた配列を生成
    data = _.filter(data,(obj)=>{
      return obj.id != monstterId && obj.id != ceoId
    });

    // 人をグループごとに分けてシャッフル
    var personGroupL =  _.where(data, { group: 'left'});
    personGroupL = _.shuffle(personGroupL);
    var personGroupR =  _.where(data, { group: 'right'});
    personGroupR = _.shuffle(personGroupR);

    // 辞めた人を補充するために配列を2重に
    personGroupR = personGroupR.concat(personGroupR);
    personGroupL = personGroupL.concat(personGroupL);

    // monsterとceoを重複させないため最後に追加
    // monsterを所定の位置に
    personGroupR.splice( 2, 0, monster );
    //ceoを所定の位置に
    personGroupL.splice( 11, 0, ceo );



    // 場所を左右に分ける
    var posGroupL = _.filter(positions, (obj)=>{
      return obj.rev == true;
    });
    var posGroupR = _.filter(positions, (obj)=>{
      return obj.rev == false;
    });

    // 人グループを場所具クループの数とあわせる
    personGroupL = personGroupL.slice(0,posGroupL.length);
    personGroupR = personGroupR.slice(0,posGroupR.length);

    // 人と場所を左右それぞれで統合
    var groupL = _.map(posGroupL, (element, index, array)=> {
      return _.extend(element, personGroupL[index]);
    });
    var groupR = _.map(posGroupR, (element, index, array)=> {
      return _.extend(element, personGroupR[index]);
    });
    //グループを統合
    var group = groupL.concat(groupR);
    // 高さ順にソート
    this.data = _.sortBy(group, (item)=>{
      return item.order;
    });

    // console.log(this.width, this.height);
    this.persons = [];
    for (var i = 0; i < this.data.length; i++ ){
      var data = this.data[i];
      data.index = i;
      this.person = new Person(data);
      // this.person.defaultTop = this.person.top;
      this.persons.push(this.person);
    }
    return this.persons;
  }

}
class Top{
  constructor(){
    //人物データを読み込み
    this.persons = app.personsArr;

    //カスタムスクロールバーを読み込み
    if ( app.ua.isPC && !app.ua.isIE ){
      this.scrollBar = new ScrollBar('#surface');
    }
    //リサイズ時の挙動
    this.$surface = $('#surface');
    this.scale = 1;

    this.fisSize();

    $(window).on({
      resize: ()=>{
        //サイズを更新
        TweenMax.set('#main', { height: (util.win.h - app.topMainHeightShort) / app.verticalScaleY - (util.win.h * app.parseRevise) });
        TweenMax.set('#stage .content', { scaleX: app.contentScale, scaleY: app.verticalScaleY });
        // 画面の位置を微妙に調整
        this.fisSize();

        this.width = $(window).width(); //$('.content .inner').width();
        this.height = $('.content').get(0).clientHeight; //$('.content .inner').get(0).style.height;

        if ( app.ua.isIE ){
          TweenMax.set('#surface', { width: '100%', left: 0 })
          TweenMax.set('#scroller', { overflow: 'hidden', height: this.height * app.verticalScaleY });
        }

        this.update();

        clearTimeout(this.timer);
        this.timer= setTimeout(()=>{

          if ( app.ua.isPC && !app.ua.isIE ){
            this.scrollBar.resize(this.height,this.$surface.scrollTop() ,this.scale );
          }
          if ( app.media == 'pc' ){
            $('#mapLink').attr({
              href: 'https://goo.gl/maps/mq9a7Au3hH72'
            })
            .text('Google Mapで見る')
          } else {
            $('#mapLink').attr({
              href: 'http://maps.apple.com/?q=35.655173, 139.694999'
            })
            .text('Map Appで見る')
          }
        },1000);

      },
    })

    $.ajax('/news/').done((data)=>{
      $('#newsIndex').find('.thumbList').append(data);

      //暫定moreボタン
      var newsHeight = $('#newsIndex').find('.thumbList').get(0).clientHeight;
      $('#newsIndex').find('li').each((i,el)=>{
        var t = $(el).get(0).offsetTop;

        if ( i == 2 ){
          $('.thumbList').height(t);
          return false;
        }

      });
      $('#newsIndex').find('.more').on({
        click: (e)=>{
          TweenMax.to(e.currentTarget, 0.5, { autoAlpha: 0 });
          TweenMax.to($('#newsIndex').find('.thumbList'), 0.5, { height: newsHeight,
            // onUpdate: ()=>{
            //   $(window).resize();
            // },
            onComplete: ()=>{
              $(window).resize();
            }
          });
          // $(e.currentTarget).
        }
      });

      $('#newsIndex').find('li a').on({
        click: (e)=>{
          var postId = $(e.currentTarget).data('postid');
          app.modals.news.setContent(postId);
          app.modals.open('news');
          return false;
        }
      });
      $(window).resize();

    })
    .fail((err)=>{
      console.log(err);
    })




    this.graphs = [];
    $.each($('.graph'), (i,el)=>{
      var graph = new Graph('graph'+(i+1));
      this.graphs.push(graph);
    })


    var view, relative,
        min, max, offset, reference, pressed, xform,
        velocity, frame, timestamp, ticker,
        amplitude, target, timeConstant;

    function ypos(e) {
        // touch event
        if (e.targetTouches && (e.targetTouches.length >= 1)) {
            return e.targetTouches[0].clientY;
        }

        // mouse event
        return e.clientY;
    }

    const scroll = (y)=> {
      // console.log(y, max, min);
        // offset = $(view).scrollTop();

        this.offset = (y > max) ? max : (y < min) ? min : y;
        $(view).scrollTop(this.offset);
        // view.style[xform] = 'translateY(' + (-this.offset) + 'px)';
    }

    const track = ()=> {
        var now, elapsed, delta, v;

        now = Date.now();
        elapsed = now - timestamp;
        timestamp = now;
        delta = this.offset - frame;
        frame = this.offset;

        v = 1000 * delta / (1 + elapsed);
        velocity = 0.8 * v + 0.2 * velocity;
    }

    const autoScroll=()=> {
        var elapsed, delta;

        if (amplitude) {
            elapsed = Date.now() - timestamp;
            delta = -amplitude * Math.exp(-elapsed / timeConstant);
            if (delta > 0.5 || delta < -0.5) {
                scroll(target + delta);
                requestAnimationFrame(autoScroll);
            } else {
                scroll(target);
            }
        }
    }

    const tap =(e)=> {
        pressed = true;
        reference = ypos(e);

        velocity = amplitude = 0;
        frame = this.offset;
        timestamp = Date.now();
        clearInterval(ticker);
        ticker = setInterval(track, 100);

        // e.preventDefault();
        e.stopPropagation();
        // return false;
    }

    const drag=(e)=> {
        var y, delta;
        if (pressed) {
            y = ypos(e);
            delta = reference - y;
            if (delta > 2 || delta < -2) {
                reference = y;
                scroll(this.offset + delta);
            }
        }
        // e.preventDefault();
        e.stopPropagation();
        // return false;
    }

    const release = (e)=> {
        pressed = false;

        clearInterval(ticker);
        if (velocity > 10 || velocity < -10) {
            amplitude = 0.8 * velocity;
            target = Math.round(this.offset + amplitude);
            timestamp = Date.now();
            requestAnimationFrame(autoScroll);
        }

        // e.preventDefault();
        e.stopPropagation();
        // return false;
    }



    view = this.$surface.get(0);

    this.$surface.on({
      touchstart: (e)=>{
        this.startY = e.targetTouches[0].pageY;
        tap(e);
      },
      touchmove:(e)=>{
        this.moveY = e.targetTouches[0].pageY;
        // var scrTop = this.$surface.scrollTop();
        var scrTop = this.offset;
        max = this.height * app.verticalScaleY - util.win.h/this.scale;

        if ( scrTop <= 0 && this.startY < this.moveY ) {
          return false;
        }
        if ( scrTop+10 > this.height * app.verticalScaleY - util.win.h/this.scale && this.startY > this.moveY) {
          return false;
        }
        drag(e)

      },
      touchend:(e)=>{
        release(e)
      },
      scroll: (e)=>{
        // console.log("scroll");
        var scrTop = this.offset = this.$surface.scrollTop();
        // var scrTop = this.offset;
        scrTop = Math.max(scrTop, 0);
        scrTop = Math.min(scrTop+10, this.height * app.verticalScaleY - util.win.h/this.scale )
        if ( scrTop != this.exScrTop ){
          $.each(this.persons, (i,person)=>{
            person.update();
            person.walkTl.pause();
          });
          $.each(this.graphs, (i,graph)=>{
            graph.update();
            graph.tl.pause();
          });

          if ( app.media == 'pc'){
            this.scrollBar.update(scrTop);
          }
          this.exScrTop = scrTop;

        }
      }
    });
    max = $('.content').get(0).clientHeight;
    this.offset = min = 0;
    pressed = false;
    timeConstant = 325; // ms



    // this.ticker = new Ticker();
    // this.ticker.move();

    // トップページを生成
    // scene情報を生成
    app.scenes = [];
    $.each($('.scene'), (i,scene)=>{
      var o = {
        el: scene,
        id: $(scene).attr('id'),
        height: scene.clientHeight,
        top: scene.offsetTop,
      };
      app.scenes.push(o);
    });


    // console.log("resize");
    $(window).resize();

  }
  fisSize(){
    TweenMax.set(this.$surface, { scale: 1 });
    var surfaceH = this.$surface.outerHeight();
    //scale前の値を割り出す
    var h = surfaceH ;
    // 新しいscaleで上書き
    this.scale = util.win.h / h;
    // surfaceをscale
    TweenMax.set(this.$surface, { scale: this.scale });
    TweenMax.set('#stage', { y: 0 });
    var off = $('#stage').data('offset')
    var t = this.$surface.position().top + (off*2);
    TweenMax.set('#stage', { y: -t });
    $('#stage').attr('data-offset', t);
    // console.log(util.win.h , app.topMainHeightShort  , app.parseRevise );
    TweenMax.set('#scroller .inner',{ paddingTop: (util.win.h - app.topMainHeightShort)  * app.parseRevise });

  }
  start(){
    //リファラーを取得
    var referrer = document.referrer;
    this.isInternal = /grenge.co.jp/.test(referrer);

    var hash = location.href.split('#/')[1]
    if ( hash ){
      this.introSkip();
      // setTimeout( ()=> {
      util.smoothScroll.toAnchor('#'+hash);
      // },1000);
    } else if ( this.isInternal ) {
      this.introSkip();
    } else {
      this.introTl.play(0);
    }

    //初回表示分をアップデート
  }
  createTimeline(){

    $.each(this.persons, (i,person)=>{
      // シーン情報取得
      var parent = _.find(app.scenes, (el)=>{
        if  ( el.id == person.parent ){
          return el;
        }
      });
      // シーンに応じて配置方法を変更
      if ( person.parent == 'main' ){
        // .mainのみ高さが可変なのでパーセントで配置
        if ( $.isArray(person.defaultTop) ){
          if ( app.media == 'pc'){
            person.top = parent.height * person.defaultTop[0];
          } else {
            person.top = parent.height * person.defaultTop[1];
          }
          // console.log(person.defaultTop);
        } else {
          person.top = parent.height * person.defaultTop;
        }
      }
      if ( app.ua.isIE ){
        TweenMax.set(person.$obj, { x: person.left, top: person.top });
      } else {
        TweenMax.set(person.$obj, { x: person.left, top: person.top , skewX: -person.per });
      }
      TweenMax.set(person.$obj.find('.person'), { rotationY: person.direction });
      // それぞれシーンに配置
      var $personsWrapper = this.$surface.find(`#${person.parent} .persons`);
      $personsWrapper.append(person.$obj);
      // アップデート
      person.createTimeline();
      person.update();

      $.each(this.graphs, (i,graph)=>{
        graph.createTimeline();
        graph.update();
      });

    });


    // イントロ用のタイムライン
    this.introOffsetY = 2000;
    TweenMax.set('#scroller', { y: this.introOffsetY })
    this.introTl = new TimelineMax({
      paused: true,
      onStart: ()=>{
        for ( var i = 0; i < 8; i++ ){
          this.persons[i].walkTl.progress(0,false);
        }
      },
      onComplete: ()=>{
        this.introViewd = true;
      }
    })
    // .to('#intro h2', 1, { autoAlpha: 1 })
    // .to({},1,{})

    .to(this, 2, { introOffsetY: 0, ease: Power2.easeOut,
      onUpdate: ()=>{
        TweenMax.set('#scroller', { y: this.introOffsetY })
      }
    })
    .add(()=>{
      for ( var i = 0; i < 8; i++ ){
        this.persons[i].walkTl.duration(3);
        this.persons[i].walkTl.play(0);
      }
    },'-=0.3');

    // 条件によって再生させるかを決める
    if ( this.introViewd == true ){
      this.introSkip();
    }
    // this.introTl.stop().progress(1,false);
// console.log("create");
  }
  introSkip(){
    // console.log("vieed");
    // イントロを閲覧後はアニメーションを表示させない
    this.introTl.stop().progress(1,false);
    for ( var i = 0; i < 8; i++ ){
      this.persons[i].walkTl.progress(1,false);
    }
  }
  update(){
    // 各sceneのサイズをアップデート
    $.each(app.scenes, (i,scene)=>{
      scene.height = scene.el.clientHeight;
      scene.top = scene.el.offsetTop;
    });
    // タイムラインを作りなおし
    this.createTimeline();
  }
}

class Graph {
  constructor(id) {
    this.id = id;
    this.$container = $('#'+id);
    this.$img = this.$container.find('img');

    // this.createTimeline();
  }
  createTimeline(){
    var recruit = _.find(app.scenes, (el)=>{
      if  ( el.id == 'recruit' ){
        return el;
      }
    });
    this.top = this.$container.get(0).offsetTop + recruit.top;
    // console.log('top'+this.top);
    this.$surface  = $('#surface');

    this.tl = new TimelineMax({
      paused: true
    })
    .to({}, this.top-(util.win.h/app.verticalScaleY)+100 , {})
    .fromTo(this.$img, (util.win.h/app.verticalScaleY)/2, { x: 0}, { x: -590 * 9, ease: SteppedEase.config(9) })
    // console.log('top:' ,this.top-(util.win.h/app.verticalScaleY));

  }
  update(){
    var scTop = this.$surface.scrollTop()/app.verticalScaleY;
    if ( scTop > this.top -(util.win.h/app.verticalScaleY) && scTop < this.tl.totalDuration() ){
      this.tl.seek(Math.ceil(Math.max(0,scTop )), false);
    } else if ( scTop > this.tl.totalDuration()) {
      this.tl.progress(1, false);
    } else {
      this.tl.progress(0, false);
    }
  }
}

class Person {
  constructor(data) {
    this.width = 170;
    this.id = data.id;
    this.scale = 1.3;
    $.extend(this,data);
    // console.log(this);
    // this.rev = this.left > 0 ? true : false;
    this.left = data.left-(this.width/2);
    // console.log(this.left, this.order);
    // this.per = (this.left/util.win.w*100) - 50;
    this.per = (data.left/40)
    this.direction = this.rev ? 180 : 0;
    this.scrSync = data.scrSync;
    // var num = ('0'+(Math.floor(Math.random()*13)+1)).slice(-2);
    // if ( this.id > '18' || this.id == '01' || this.id == '16' ){
    //   this.id = 18;
    // }
    var num = this.id
    var tmp =
    `<div id="id${data.id}" class="object">
      <div class="person">
        <div class="sprite">
          <img class="body" src="/assets/img/person/thumb/${num}_walk.png" alt="">
          <img class="shadow" src="/assets/img/person/thumb/${num}_walk_s.png" alt="">
        </div>
      </div>
      <a href="#" class="area">
        <div class="tapus">
          <img src="/assets/img/txt_tapus.png" alt="" />
        </div>
      </div>
    </div>`;
      // <div class="shadow"><img src="/assets/img/person/shadow.png" alt="" /></div>
    this.$obj = $(tmp);
    this.$objPerson = this.$obj.find('.person');
    // console.log(data.rev);
    this.message = `<section id="message">
                    <p>グレンジは友人とのコミュニケーションを<br>軸としたソーシャルアプリケーションの<br>企画・開発をする会社です。</p>
                    <p>ソーシャルというワードは<br>インターネットの業界において<br>流行語のように語られていますが、<br>その本質は人間の根源的な欲求に<br>基づいたものであり、<br>普遍的なものだと思います。</p>
                    <p>人はコミュニケーションなしでは<br>生きていけません。</p>
                    <p>コミュニケーションのきっかけは<br>人の感情であり、<br>感情に基づいて設計された<br>ソーシャルメディアの発展は<br>インターネットの持つ価値を<br>情報から共感へとシフトさせています。</p>
                    <p>我々グレンジは、<br>このパラダイムシフトを<br>絶好のチャンスととらえ、<br>世界中の人たちが使うような<br>サービス、コンテンツを作りたいと<br>本気で考えています。</p>
                   </section>`;




    // TweenMax.set('#persons', { height: $('.content').get(0).clientHeight });
    this.$tempPersonDetailMain = app.$tempPersonDetailMain.clone();
    this.$tempOtherPeople = app.$tempOtherPeople.clone();


    this.$surface = $('#surface');

    this.minPersonH = 85; // パーセント
    this.maxPersonH = 145; // パーセント
    this.rangeParsonH = this.maxPersonH - this.minPersonH;
    // this.$surface.on({
    //   scroll: ()=>{
    //     this.update();
    //   }
    // });
    this.$obj.find('.area').on({
      mouseenter: ()=>{
        this.$obj.find('.person').addClass('hover')
      },
      mouseleave: ()=>{
        this.$obj.find('.person').removeClass('hover')
      },
      click: ()=>{

        if ( this.id == '00' ){
          util.smoothScroll.toAnchor('#product');
          return;
        }
        if ( app.modals.isOpen ){
          this.change();
        } else {
          this.setDetailPage();
          app.modals.open('detail');
          app.modals.$inner.scrollTop(0);
        }
        return false;
      }
    });

    this.createDetail();
  }
  change(){
    this.changeTl = new TimelineMax()
    .to(app.modals.detail.$container , 0.3, { autoAlpha: 0 })
    .add(()=>{
      this.setDetailPage();
    })
    .to(app.modals.detail.$container, 0.3, { autoAlpha: 1 })
  }

  update(){
    var scTop = this.$surface.scrollTop()/app.verticalScaleY;
    var posTop =  this.scene.top + this.top - scTop;
    // console.log(scTop);
    // console.log(posTop);
    // console.log(util.win.h );
    if ( posTop > -300 && posTop < (util.win.h/app.verticalScaleY) + 300 ){ // 300は画面外の分
      TweenMax.set(this.$obj, {display: 'block'});
      var unit = posTop / (util.win.h/app.verticalScaleY) * this.rangeParsonH;
      var scalePercent = (this.minPersonH - unit + this.rangeParsonH )/app.verticalScale;
      // console.log(scalePercent);
      // console.log(scalePercent/100);

      if ( app.ua.isIE ){
        TweenMax.set(this.$obj, { scale: this.scale });
      } else {
        TweenMax.set(this.$obj, { scaleY: (scalePercent/100) * this.scale, scaleX: this.scale  });
      }
      this.additionalDirection
      if ( this.scrSync == true ){
        var additionalDirection = scTop > this.exScTop ? 0 : 180;
        if ( scTop < this.walkTl.totalDuration() ){
          // TweenMax.set(this.$obj, { rotationY: this.direction + additionalDirection  });

          // console.log(this.id, scTop);
          this.walkTl.seek(Math.ceil(Math.max(0,scTop )), false);
          TweenMax.set(this.$objPerson, { rotationY: this.direction + additionalDirection  });
        } else {

          this.walkTl.progress(1, false);
          TweenMax.set(this.$objPerson, { rotationY: this.direction   });
        }
      } else {
        var additionalDirection = scTop > this.exScTop ? 180 : 0;
        if ( scTop < this.walkTl.totalDuration() && scTop > 0 ){
          // console.log("範囲内");
          // TweenMax.set(this.$obj, { rotationY: this.direction + additionalDirection  });

          // console.log(this.id, scTop);
          this.walkTl.seek(Math.ceil(Math.max(0, this.walkTl.totalDuration() - scTop )), false);
          TweenMax.set(this.$objPerson, { rotationY: this.direction + additionalDirection  });
        } else if ( scTop <= 0) {
          this.walkTl.progress(1, false);
          TweenMax.set(this.$objPerson, { rotationY: this.direction });
          // TweenMax.set(this.$objPerson, { rotationY: this.direction });
        } else {
          this.walkTl.progress(0, false);
        }
      }

      this.exScTop = scTop;
    } else {
      TweenMax.set(this.$obj, {display: 'none'});
    }
  }
  createTimeline(){
    this.scene = _.find(app.scenes, (el)=>{
      if  ( el.id == this.parent ){
        return el;
      }
    });

    this.tapusSwingTl = new TimelineMax({
      paused: true
    })
    .fromTo(this.$obj.find('.tapus'), 0.5,  { rotation: 0 }, { rotation: -5, repeat: -1, yoyo: true, ease: SteppedEase.config(1)  }, 0)

    this.tapusTl = new TimelineMax({
      paused: true,
    })
    .fromTo(this.$obj.find('.tapus'), 0.2, { scale: 0 , x: '-50%' }, { scale: 0.75, ease: Back.easeOut });


    this.move = 850 * (this.rev ? -1 : 1);
    this.stepPattern = 4; // 変更しない
    this.stepRepeat = 3;
    this.stepDelay = 50;
    // this.walkStartOffset = 300;
    this.walkStartOffset = (this.order == 33 || this.order == 34 ) ? 500 : 300;

    this.walkTl = new TimelineMax({
      paused: true,
    })
    // .to({},Math.min(this.top - util.win.h, util.win.h), {})
    .to({}, this.scene.top + this.top-(util.win.h/app.verticalScaleY) - this.walkStartOffset, {})
    .add('move');
    //pcの時にはfadein
    if ( app.media == 'pc'){
      this.walkTl
      // .set(this.$obj,{ autoAlpha: 1})
      .fromTo(this.$obj, 300, { autoAlpha: 0},{ autoAlpha: 1},'move')
    } else {
      this.walkTl
      .set(this.$obj,{ autoAlpha: 1})
    }

    if ( app.ua.isIE ){
        this.walkTl
        .fromTo(this.$obj, this.stepPattern * this.stepRepeat * this.stepDelay ,
          { x: this.left + this.move  },
          { x: this.left, ease: SteppedEase.config((this.stepPattern) * this.stepRepeat - 1)},
        'move' )
    } else {
        this.walkTl
        .fromTo(this.$obj, this.stepPattern * this.stepRepeat * this.stepDelay ,
          { x: this.left + this.move , skewX: -((this.left + this.move + this.width/2)/50) },
          { x: this.left, skewX: -((this.left + this.width/2)/50), ease: SteppedEase.config((this.stepPattern) * this.stepRepeat - 1)},
        'move' )
    }

    this.walkTl
    .fromTo(this.$obj.find('.sprite'), this.stepPattern * this.stepDelay,
      { x: - this.width },
      { x: - this.width * this.stepPattern , ease: SteppedEase.config(this.stepPattern-1), repeat: this.stepRepeat-1 },
    'move')

    .to(this.$obj.find('.sprite'),  0.1, { x: 0 })
    // .to(this.$objPerson, 0.1,{ rotationY: this.rev ? 0 : 180  })
    .add(()=>{
      if ( this.tapus == true ){
        this.tapusTl.reverse();
        this.tapusSwingTl.stop();
      }
    })
    .to({},0.1,{})
    .add(()=>{
      if ( this.tapus == true ){
        this.tapusTl.play();
        this.tapusSwingTl.play();
      }
    })
    .to({},0.1,{})

  }
  createDetail(){
    var cont = this.$tempPersonDetailMain;
    if ( this.id == '02' ){
      cont.find('.img1').remove();
    } else {
      cont.find('.img1').attr({ src: `/assets/img/person/detail/detail_${this.id}_01.png` });
    }
    cont.find('.img2').attr({ src: `/assets/img/person/detail/detail_${this.id}_02.png` });
    cont.addClass(`id${this.id}`);
    cont.find('.position').html(this.position);
    cont.find('.name').text(this.nickName);
    cont.find('.year').text(this.year + '年入社');

    if ( this.id != '02'){
      var faqs = [];
      $.each(this.faq, (i,el)=>{
        faqs.push(`<dt>Q.${i+1} ${el.q}</dt><dd>${el.a}</dd>`);
      });
      cont.find('#faqs').html(faqs);
      cont.find('.year').show();
    } else {
      cont.find('#faqs').html(this.message);
      cont.find('.year').hide();
    }

    cont.find('.thumbs').imagesLoaded(()=>{
      this.fadeSlider = cont.find('.thumbs').slick({
        fade: true,
        dots: false,
        arrows: false,
        // autoplay: true,
        autoplaySpeed: 2000,
      })
    })
    // console.log(this.index);
    // console.log(app.otherPeopleSlider);

  }
  setDetailPage(){
    app.modals.$inner.scrollTop(0);
    $('#personDetailMain').html(this.$tempPersonDetailMain);
    setTimeout(()=>{
      app.otherPeopleSlider.slick('slickUnfilter');
      app.otherPeopleSlider.slick('slickFilter',`:not(.id${this.id})`);
      app.otherPeopleSlider.slick('setPosition');
      this.fadeSlider.slick('setPosition');
      this.fadeSlider.slick('slickGoTo', 0, true);
      this.fadeSlider.slick('slickPlay');
    },300);
    // app.otherPeopleSlider.slick('slickGoTo', this.index, true);
  }
  otherPeople(){
    var cont = this.$tempOtherPeople.clone();
    cont.addClass(`id${this.id}`);
    cont.find('.thumb').attr({ src: `/assets/img/person/detail/thumb${this.id}.png` });
    cont.find('.position').html(this.position);
    cont.find('.name').text(this.nickName);
    cont.find('.year').text(this.year + '年入社');
    cont.on({
      click: ()=>{
        if ( app.modals.isOpen ){
          this.change();
        } else {
          this.setDetailPage();
          app.modals.open('detail');
        }
        return false;
      }
    })
    return cont;
  }
}

  class Modals {
    constructor(){
      this.$modals = $('#modals');
      this.$inner = $('#modals .inner');
      this.$content = $('#modals .inner .modal');
      this.$close = $('#modals #close,.btn.close');
      this.isOpen = false;
      this.current = '';

      this.$modals.on( "touchmove.noScroll", (e)=>{
        e.stopPropagation();
      });


      this.tl = new TimelineMax({
        paused: true,
        onReverseComplete: ()=>{
        TweenMax.set(this.$modals,{ display: 'none' });
          TweenMax.set(this.$content,{ display: 'none' });
          $(window).off('.noScroll');
          TweenMax.set('#stage', { autoAlpha: 1 })
        },
        onStart: ()=>{
          TweenMax.set(this.$modals,{ display: 'block' });
          TweenMax.set('#stage', { autoAlpha: 0 })
        }
      })

      $('.openModal').on({
        click: (e) =>{
          var id = $(e.currentTarget).data('modal');
          this.open(id);
        }
      });

      this.$close.on({
        click: ()=>{
          this.close();
        }
      });

      if ( util.getUrlVars('m') ){
        setTimeout(()=>{
          this.open(util.getUrlVars('m'));
        },500);
      }

      this.$inner.on({
        touchstart: (e)=>{
          this.scrollHeight = this.$content.outerHeight()-this.$inner.outerHeight();
          this.startY = event.targetTouches[0].pageY;
          // console.log(this.scrollHeight);
        },
        touchmove:(e)=>{
          this.moveY = event.targetTouches[0].pageY;
          var scrTop =  this.$inner.scrollTop();

          if ( scrTop <= 0 && this.startY < this.moveY ) {
            return false;
          }
          if ( scrTop+10 > this.scrollHeight && this.startY > this.moveY) {
            return false;
          }
        }
      })
    }

    open(id){
      if(!this.isOpen){
        this.tl.play();
          $(window).on("touchmove.noScroll", (e)=>{
            e.preventDefault();
          });
        this.isOpen = true;
        this.current = id;
        this[id].start();
        this.reminderTop = util.win.scrTop;
        $('html').addClass('modal');

      // } else {
      //   this[id].change();
      }
    }


    close(){
      if(this.isOpen){
        app.modals.$inner.scrollTop(0);
        this.tl.reverse();
        this.isOpen = false;
        this[this.current].close();
        $('html').removeClass('modal');
        $(window).scrollTop(this.reminderTop);
      }
    }
  }

  class Modal {
    constructor (id) {
      this.id = id;
      this.$modal = $('#'+this.id);
      this.$container = this.$modal.find('.container');
    }
    open (){
      app.modals.open(this.id);
    }
    start (){
      // TweenMax.set(this.$modal,{ display: 'block' });
      TweenMax.fromTo(this.$modal, 0.5, { display: 'none', autoAlpha: 0 }, { display: 'block', autoAlpha: 1 });
      app.modals.$inner.scrollTop(0);
    }

    close(){
    }
  }

  class News extends Modal {
    constructor(id){
      super(id);
    }
    start(){
      super.start();
      TweenMax.set(this.$container , { autoAlpha: 0 });
      this.$container.find('#ajaxContent').empty();
    }
    setContent(postId){
      // alert(postId)
      $.ajax(`/news/?p=${postId}`)
      .done((data)=>{
        var $contents = $(data).find('#newsDetail').children();
        new TimelineMax()
        .add(()=>{
          $('#ajaxContent').html($contents);
          app.modals.$inner.scrollTop(0);
        })
        .to(this.$container, 0.3, { autoAlpha: 1 })

        $contents.find('.prev_post>a, .next_post>a').on({
          click: (e)=>{
            var postId = $(e.currentTarget).data('postid');
            new TimelineMax()
            .to(this.$container , 0.3, { autoAlpha: 0 })
            .add(()=>{
              this.setContent(postId);
            })

            return false;
          }
        })


      })


    }
  }

  class Welfare extends Modal {
    constructor(id){
      super(id);
    }
  }
  class ModalContact extends Modal {
    constructor(id){
      super(id);
      var rules = {
        name: { required: true },
        // company: { required: true },
        // division: { required: true },
        // phone: { required: true /* number: true, maxlength: 11, minlength: 10 */},
        mail: { required: true, email: true },
        inquiry: { required: true },
        // upfile: { required: true },
      };
      this.form = new Form('formContact', '/php/api/contact.php', rules, this);
    }
    start(){
      super.start();
      this.form.reset();
    }
  }
  class Entry extends Modal {
    constructor(id){
      super(id);
      var rules = {
        occupation: { required: true },
        name: { required: true },
        kana: { required: true },
        // age: { required: true },
        // gender: { required: true },
        // phone: { required: true /* number: true, maxlength: 11, minlength: 10 */},
        mail: { required: true, email: true },
        // zip: { required: true },
        // address: { required: true },
        // career: { required: true },
        // file: { required: true, extension: 'jpg|png|gif' }
        upfile1: { required: true },
        upfile2: {},
        upfile3: {},
        note: {}
      };
      this.designer = [
        'artdirector',
        'uiux-designer',
        'animation-designer',
        '2dcg-effect-designer',
        '3dcg-motion-designer',
        '3dcg-effect-designer',
        '3dcg-model-designer',
        'illustrator',
      ]

      this.form = new Form('formEntry', '/php/api/recruit.php', rules, this);
    }
    start(){
      super.start();
      this.form.reset();
      var pathname = location.pathname.split('/');
      pathname = pathname[pathname.length-2];
      $('#entry select[name="occupation"] option').filter(function(index){
        return $(this).attr('name') == pathname;
      }).prop('selected', true);

      var isPortfolio =  _.indexOf(this.designer, pathname) >= 0 ? true : false;
      if ( isPortfolio ){
        this.form.$form.find('.portfolio').show();
      } else {
        this.form.$form.find('.portfolio').hide();
      }
    }
  }
  class Detail extends Modal {
    constructor(id){
      super(id);
      var uniquePersons = _.unique(app.personsArr,'id');

      this.persons = uniquePersons;

      var otherPeoples = [];
      $.each(this.persons, (i,el)=>{
        // console.log(el.otherPeople());;
        if ( el.id == '00' ){
          return;
        }
        var cont = el.otherPeople();
        otherPeoples.push(cont);
      });
      $('#otherPeople').html(otherPeoples);

      app.otherPeopleSlider = $('#otherPeople').slick({
        appendArrows: $('#otherPeople'),
        prevArrow: '<div class="arrow prev"></div>',
        nextArrow: '<div class="arrow next"></div>',
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        draggable: false,
        centerPadding: 0,
        responsive: [
          {
            breakpoint: 760,
            settings: {
              infinite: true,
              speed: 200,
              // centerMode: true
              // centerPadding: 0,
              draggable: true,
              slidesToShow: 4,
              slidesToScroll: 1,
              swipeToSlide: true,
              arrows: false
            }
          },
        ]
      });

    }
    start(){
      super.start();

    }
  }


  class Form {
    constructor(id, postUrl, rule, parent){
      this.rule = rule;
      this.postUrl = postUrl;
      this.parent = parent;
      this.$modalContaier = this.parent.$modal.find('.container');;
      this.$form = $('#'+id);
      this.$confirm = this.$form.siblings('.confirm');
      this.$complete = this.$form.siblings('.complete');
      //標準エラーメッセージの変更
      $.extend($.validator.messages, {
        email: '正しいメールアドレスを入力してください。',
        required: 'この項目は必須となります。',
        number: '半角数字で入力してください。',
        minlength: '10桁～11桁の半角数字を入力してください',
        maxlength: '10桁～11桁の半角数字を入力してください'
      });
      //バリデーションの追加
      // $.validator.addMethod("zip", function(value, element) {
      //   return this.optional(element) || /^[0-9\-]+$/.test(value);
      // }, "半角数字で入力してください。");
      // $.validator.addMethod('filesize', function(value, element, param) {
      //     // param = size (en bytes)
      //     // element = element to validate (<input>)
      //     // value = value of the element (file name)
      //     return this.optional(element) || (element.files[0].size <= param)
      // });

    　//追加ルールの定義
      // var methods = {
      //   phone: function(value, element){
      //     return this.optional(element) || /^\d{11}$|^\d{3}-\d{4}-\d{4}$/.test(value);
      //   }
      // };

      //メソッドの追加
      // $.each(methods, function(key) {
      //   $.validator.addMethod(key, this);
      // });

      //入力項目の検証ルール定義


      //入力項目ごとのエラーメッセージ定義
      var messages = {
        occupation: {
          required: "選択してください。"
        }
      };

      // form用event
      this.$form.find('.submit').on({
        click: ()=>{
          this.$form.submit();
        }
      });

      this.$form.find('.back').on({
        click: ()=>{
          app.modals.close();
        }
      });

      this.$form.validate({
        rules: this.rule,
        messages: messages,
        submitHandler: (form)=> {
          this.formData = new FormData( this.$form.get(0) );


          this.confirm();

          return false;
        },

        errorPlacement: function(error, element){
          error.appendTo(element.parents('dd').find('.err'));
          // if (element.is('select')) {
          //   error.appendTo(element.parent().parent('.err'));
          // } else if (element.is(':radio')) {
          //   error.appendTo(element.parents('dd').find('.err'));
          // } else {
          //   error.appendTo(element.parents('dd').find('.err'));
          // }
        }
      });

      var $file = this.$form.find('input.upfile');
      $.each($file, (i,el)=>{
        var $this = $(el);
        var $parent = $this.parents('dd');
        $this.on({
          change: ()=>{
            var val = $this.get(0).files[0];
            var name = $this.attr('name');
            if ( val ){
              this.$confirm.find(`.${name}`).text(val.name);
              $parent.find('.filename').text(val.name);
              $parent.find('.attachText').text('ファイルの添付をやり直す')
            } else {
              this.$confirm.find(`.${name}`).text('');
              $parent.find('.filename').text('選択されていません');
              $parent.find('.attachText').text('ファイルを添付する')
            }
          }
        });
      });

      // confirm event
      this.$confirm.find('.back').on({
        click: ()=>{
          this.form();
        }
      });
      this.$confirm.find('.submit').on({
        click: ()=>{
          this.send();
        }
      });
    }
    reset(){
      this.$form.get(0).reset();
      this.$form.find('input.upfile').change();
      app.modals.$inner.scrollTop(0);
      TweenMax.set([ this.$confirm,this.$complete ], { autoAlpha: 0, display: 'none' })
      TweenMax.set(this.$form, { autoAlpha: 1, display: 'block' })
    }
    form(){
      this.change(this.$confirm, this.$form);
    }
    confirm(){
      // for (var [key, val] of this.formData.entries()) {
      //   if ( key == 'upfile' || key == 'upfile1' || key == 'upfile2' || key == 'upfile3' ){
      //     this.$confirm.find(`.${key}`).text(val.name);
      //   } else {
      //     this.$confirm.find(`.${key}`).text(val);
      //   }
      // }

      //サファリなどが対応してないのでこちらの形に変更
      this.formDataText = _.chain(this.$form.serializeArray())
        .map( function(input) {
          return [input.name, input.value];
        })
        .object().value();

      $.each(this.formDataText, (key,val)=>{
        this.$confirm.find(`.${key}`).text(val);
      });

      this.change(this.$form, this.$confirm);

    }
    send(){
      // console.log(this.postUrl,this.formData);
      $.ajax(this.postUrl, {
        type: 'post',
        dataType: 'json',
        data: this.formData,
        processData: false,
        contentType: false,
      })
      .done((json)=>{
        // console.log(json);
        if ( json.result == true ){
          this.complete();
        }
      })
      .fail(()=>{
        if ( location.href.indexOf('192.168') != -1 ){
          this.complete();
        } else {
          alert('失敗');
        }
      })
    }
    complete(){
      this.change(this.$confirm, this.$complete);
    }
    change(hide,show,){
      var hideCont= hide;
      var showCont = show;
      new TimelineMax()
      .to(hideCont, 0.3, { autoAlpha: 0 })
      .add(()=>{
        app.modals.$inner.scrollTop(0);
      })
      .set(showCont, { display: 'block' })
      .set(hideCont, { display: 'none' })
      .to(showCont, 0.3, { autoAlpha: 1 })
    }
  }

class Ticker{
  constructor(){
    const speed = 8;
    const $wrapper = $('#newsTicker');
    const $texts = $wrapper.find('ul');
    const $text = $texts.find('li');
    var last = $text.first().clone();
    $texts.append(last);
    const width = last.get(0).offsetLeft;
    this.tl = new TimelineMax({
      paused: true
    })
    .to( $texts, width/750 * speed, {
      x: - width,
      repeat: -1,
      ease: Power0.easeNone
    });
  }
  move(){
    this.tl.play();
  }
  stop(){
    this.tl.stop();
  }
}

class ScrollBar {
  constructor( id ){
    this.$container = $(id);
    this.$rail = $('#scrollRail');
    this.$bar = $('#scrollBar');
    this.offsetTop = 50;
    this.$rail.show();
    Draggable.create(this.$bar, {
      type:"y",
      edgeResistance:1,
      bounds:this.$rail,
      cursor: 'pointer',
      onDrag:()=>{
        this.dragUpdate(this.draggable.y);

      }
    });
    this.draggable = Draggable.get(this.$bar);
    this.draggable.update();

  }
  resize( containerH, scrTop, scale){
    this.scale = scale;
    this.containerH = containerH;
    this.railHeight = util.win.h - this.offsetTop;
    this.railRatio = this.railHeight / containerH;
    this.barH = (util.win.h-this.offsetTop) * this.railRatio /app.verticalScaleY;
    TweenMax.set(this.$rail, { top: this.offsetTop });
    TweenMax.set(this.$bar, { height: this.barH  });

    // TweenMax.set(this.$bar, { height: conten})
    // console.log(containerH,scrTop);
  }
  update(scrollTop){
    this.top = scrollTop * this.railRatio / app.verticalScaleY;
    TweenMax.set(this.$bar, { y: this.top });
  }
  dragUpdate(y){
    var scrollTop = this.draggable.y  / this.railRatio * app.verticalScaleY;
    $('#surface').scrollTop(scrollTop);
  }
  drag2(){
    this.x,
    this.y;
    this.$bar.on({
      mousedown:(e)=>{
        e.preventDefault();
        this.y = e.clientY;
        this.isDrag = true;
        // console.log(this.y);
      },
      mousemove:(e)=>{
        e.preventDefault();
        if ( this.isDrag == true ){
          this.move = this.y - e.clientY;
          $('#surface').scrollTop(-this.move);
          TweenMax.set(this.$bar, {y: -this.move });
          // console.log(this.move);
        }
      },
      mouseup: (e)=>{
        e.preventDefault();
        this.isDrag = false;
        // console.log("up");
        // this.move = 0;
        // this.y = 0;


      }
    })

  }

}

$(()=>{
  app.main = new Main();
});


// WEBPACK FOOTER //
// ./src/assets/js/_main.es6